import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import "./about.css";
import GulfemFoto from "../assets/gulfem-dikici-celikay-klinik-psikolog.jpg";

function About() {
  const [showMore, setShowMore] = useState(false);

  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const targetId = hash.replace("#", "");

      const timer = setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          const targetPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          const startPosition = window.pageYOffset;
          const distance = targetPosition - startPosition;
          const duration = 2000;
          let start = null;

          const step = (timestamp) => {
            if (!start) start = timestamp;
            const progress = timestamp - start;

            const easeInOutQuad = (t) =>
              t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            const scrollY =
              startPosition +
              distance * easeInOutQuad(Math.min(progress / duration, 1));

            window.scrollTo(0, scrollY);

            if (progress < duration) {
              window.requestAnimationFrame(step);
            }
          };
          window.requestAnimationFrame(step);
        }
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [hash]);

  const handleShowMoreToggle = () => {
    setShowMore(!showMore);
    setTimeout(() => {
      const element = document.getElementById("about");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };


  const shortText = `
    Merhaba, ben Klinik Psikolog Gülfem Dikici Çelikay. Lisans eğitimimi İstanbul Üniversitesi Psikoloji bölümünde, Klinik Psikoloji Yüksek Lisansımı ise Hollanda’da University of Groningen’de tamamladım. Antalya’da ergen ve yetişkinlerle yüz yüze ve online bireysel terapi seansları yürütüyor; aynı zamanda yazılar, dijital içerikler ve psikoeğitim çalışmaları aracılığıyla psikolojiye dair bilginin daha geniş kitlelere ulaşması için çalışıyorum.
Çalışmalarımda Psikodinamik Terapi, Şema Terapi, EMDR ve Somatik Deneyimleme® yaklaşımlarını bütüncül bir çerçevede kullanıyorum. Her bireyin geçmiş deneyimleriyle şekillenmiş duygu düzenleme biçimlerini ve ilişki kalıplarını; bu örüntülerin bugünkü yaşantıya etkilerini ele alıyorum. 
  `;

  const longText = [
    "Psikolojiye yönelmeden önce İstanbul Teknik Üniversitesi’nde mimarlık eğitimi aldım. Zamanla ilgimin mekanlardan çok insanların duygusal, bilişsel ve davranışsal süreçlerini anlamaya yönelik olduğunu fark ettim. Bu ilgim doğrultusunda psikolojiye yöneldim.",

    "Psikoloji lisans eğitimimi İstanbul Üniversitesi’nde yüksek onur derecesiyle tamamladım. Lisans yıllarımda aynı zamanda akademik çalışmalara yoğun ilgi gösterdim. Koç Üniversitesi, Kadir Has Üniversitesi, Bahçeşehir Üniversitesi ve TÜBİTAK’ta yürütülen çeşitli projelerde araştırma asistanlığı yaptım. Çalışma konularım arasında çocuklarda dil gelişimi, kolektif pandemi hafızası, dikkat süreçleri ve metakognisyon yer aldı.",

    "Yüksek lisansımı Hollanda’da University of Groningen’de Klinik Psikoloji (Research Master) programında tamamladım. Yüksek lisansa kabulümün yanı sıra, Hollanda Eğitim, Kültür ve Bilim Bakanlığı tarafından The Holland Scholarship bursunu almaya hak kazandım. Bu dönemde yeme davranışlarına ilişkin çalışmalarda proje sorumlusu olarak yer aldım ve açlığın duygular üzerindeki etkisini incelediğim deneysel bir tez yürüttüm (The impact of hunger on emotions: The mediating role of interoception and satiety responsiveness). Aynı zamanda öğretim asistanı olarak lisans öğrencilerine araştırma metodolojisi, istatistik ve bilimsel yazım derslerinde destek verdim.",

    "Klinik pratiğimi bütüncül bir yaklaşımla sürdürüyorum. İstanbul Üniversitesi’nde aldığım psikoloji eğitimi, psikanalitik kurama dayalı köklü teorik geleneğiyle bana kapsamlı bir klinik formasyon kazandırdı. Zaman içinde şema terapi, EMDR ve somatik uygulamalarla da çalışmaya başladım. Bu alanlarda ileri eğitimler ve klinik deneyimlerle sürekli olarak geliştirmeye devam ediyorum. Şu anda ISST onaylı şema terapisti olmak üzere Dr. Klinik Psikolog Reyhan Nuray Duman eşliğinde vaka temelli süpervizyonlara katılıyorum. Ayrıca Avrupa Akredite EMDR terapisti olma yolculuğumda Klinik Psikolog Zeynep Özmeydan ile süpervizyon çalışmalarımı sürdürüyorum. Bu kuramsal ve teknik birikimi, kişinin ihtiyaçlarına göre şekillenen bütüncül bir çerçevede uyguluyorum. Çalıştığım ekollerin merkezinde ise her zaman terapötik ilişkinin şefkatli ve düzenleyici gücünü iyileşmenin temel unsuru olarak görüyorum.",

    "Klinik pratiğimin yanı sıra akademik çalışmalara da devam ediyorum. Şema Terapi Derneği Araştırma Kurulu’nda yer alarak Türkiye’de şema terapiye ilişkin bilimsel üretim süreçlerine katkı sağlıyorum. Ayrıca Akademi OKB bünyesinde EMDR alanındaki araştırmalara destek veriyorum. Şema Terapi Derneği, EMDR Türkiye, Türk Psikologlar Derneği ve International Society of Schema Therapy (ISST) üyeliklerim aracılığıyla, mesleki topluluklar içinde aktif biçimde yer alıyor; hem klinik hem akademik düzeyde güncel bilgiyle çalışmaya önem veriyorum.",
  ];

  return (
    <>
      <Helmet>
        <title>Hakkımda | Klinik Psikolog Gülfem Dikici Çelikay</title>
        <meta
          name="description"
          content="Klinik Psikolog Gülfem Dikici Çelikay; Antalya'da Şema Terapi, EMDR ve Psikodinamik Terapi ekolleriyle yetişkin ve ergenlere yönelik bireysel terapi hizmeti sunmaktadır."
        />
        <link rel="canonical" href="https://www.siteniz.com/about" />

        {/* JSON-LD Schema: Google'ın sizi bir profesyonel olarak tanımasını sağlar */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Psychologist",
            name: "Gülfem Dikici Çelikay",
            jobTitle: "Klinik Psikolog",
            hasCredential: [
              {
                "@type": "EducationalOccupationalCredential",
                name: "Şema Terapi Eğitimi",
              },
              {
                "@type": "EducationalOccupationalCredential",
                name: "EMDR 1. ve 2. Düzey Eğitimi",
              },
              {
                "@type": "EducationalOccupationalCredential",
                name: "Psikodinamik Terapi Eğitimi",
              },
            ],
            knowsAbout: [
              "Şema Terapi",
              "EMDR",
              "Psikodinamik Terapi",
              "Somatik Deneyimleme",
            ],
            url: "https://www.siteniz.com/about",
            image:
              "https://www.siteniz.com/static/media/Gülfem-Dikici-Çelikay.jpg",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Antalya",
              addressCountry: "TR",
            },
            alumniOf: [
              { "@type": "CollegeOrUniversity", name: "İstanbul Üniversitesi" },
              {
                "@type": "CollegeOrUniversity",
                name: "University of Groningen",
              },
            ],
          })}
        </script>
      </Helmet>

      {/* İçerik */}
      <div
        id="about"
        className="row"
        style={{ backgroundColor: "rgb(239, 235, 225)", padding: "100px" }}
      >
        <div
          className="col-md-6"
          style={{ padding: "56px", position: "relative" }}
        >
          <div style={{ position: "sticky", top: "120px" }}>
            {" "}
            <img
              src={GulfemFoto}
              alt="Psikolog Gülfem Dikici Çelikay - Klinik Psikolog"
              className="img-fluid"
              style={{ borderRadius: "15px" }}
            />
          </div>
        </div>
        <div className="col-md-6 d-flex flex-column justify-content-center">
          <h1 className="text-center mb-3">HAKKIMDA</h1>
          <h5
            style={{
              textAlign: "justify",
              lineHeight: "1.6",
              fontSize: "clamp(10px, 4vw, 22px)",
            }}
          >
            {showMore
              ? longText.map((p, index) => (
                  <p key={index} style={{ marginBottom: "1.5rem" }}>
                    {p}
                  </p>
                ))
              : shortText}
          </h5>
          <button
            className="btn btn-outline-dark mt-3"
            onClick={handleShowMoreToggle}
          >
            {showMore ? "Daha Az Göster" : "Daha Fazla Göster"}
          </button>
        </div>
      </div>

      <div className="p-4" style={{ backgroundColor: "rgb(239, 235, 225)" }}>
        <h1 className="text-center">EĞİTİMLERİM</h1>

        <div
          className="education-box my-5 m-md-5"
          style={{
            backgroundColor: "white",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            borderRadius: "6px",
          }}
        >
          <section aria-label="Şema Terapi Eğitimleri">
            {/*<h3>Şema Terapi Eğitimleri</h3>*/}
            <ul>
              <li>
                Uluslararası Şema Terapi Eğitimi – Prof. Dr. Alp Karaosmanoğlu
              </li>
              <li>
                ISST Onaylı Şema Terapi Süpervizyon – Dr. Klinik Psikolog Reyhan
                Nuray Adak EMDR (Göz Hareketleri ile Duyarsızlaştırma ve Yeniden
                İşlemleme) 1.Düzey – Davranış Bilimleri Enstitüsü
              </li>
              <li>
                EMDR (Göz Hareketleri ile Duyarsızlaştırma ve Yeniden İşlemleme)
                2.Düzey – Davranış Bilimleri Enstitüsü{" "}
                <span>
                  Avrupa Aktedite EMDR Süpervizyon – Klinik Psikolog Zeynep
                  Özmeydan
                </span>
              </li>
            </ul>
          </section>
          <section aria-label="EMDR ve Travma Odaklı Eğitimler">
            {/*<h3>EMDR ve Travma Odaklı Eğitimler</h3>*/}
            <ul>
              <li>
                Karmaşık Travmada İleri Terapi Becerileri Eğitimi – Prof. Dr.
                Önder Kavakçı, Doç. Dr. Alişan Burak Yaşar, Klinik Psikolog
                Armağan Gülenay, Doç. Dr. Anıl Gündüz, Prof. Dr. Fatih Yavuz,
                Dr. Görkem Gökçelioğlu (hala devam ediyor)
              </li>
              <li>EMDR 2.0 –Prof. Dr. Ad de Jongh & Suzy Matthijssen</li>
              <li>
                EMDR ile Yetişkinlerde Bağlanma Sorunları Üzerinde Çalışmak –
                Klinik Psikolog Asena Yurtsever & Dr. Klinik Psikolog Ayşe
                Bombacı
              </li>
            </ul>
          </section>
          <section aria-label="Psikodinamik Terapi Eğitimleri">
            {/*<h3>Psikodinamik Terapi Eğitimleri</h3>*/}
            <ul>
              <li>
                Çözümlenmemiş Travma ve Bağımlılık Bozuklukları – Dr. Janina
                Fisher
              </li>
              <li>
                Beden Odaklı Şema Terapi – Dr. Klinik Psikolog Reyhan Nuray Adak
              </li>
              <li>
                Şema Terapisinde Nesiller Arası Yeniden Ebeveynlik ve Yeniden
                Yazma – Dr. Alp Karaosmanoğlu
              </li>
              <li>
                Bağlamsal Şema Terapi Eğitimi – Dr. Eckhard Roediger & Dr.
                Sevinç Göral Alkan
              </li>
            </ul>
          </section>
          <section aria-label="Bilişsel Davranışçı Terapi Eğitimleri">
            {/*<h3>Bilişsel Davranışçı Terapi Eğitimleri</h3>*/}
            <ul>
              <li>
                Şema Mod Çalışmalarında Yaşantısal Tekniklerin Kullanımı – Dr.
                Esra Ersayan
              </li>
              <li>Travma ve Bağımlılığı İyileştirme – Dr. Gabor Maté</li>
              <li>Kriz, Travma, Ölüm ve Yas Danışmanlığı – Dr. Nevin Dölek</li>
              <li>
                Somatik Deneyimleme Giriş Semineri – Somatik Deneyimleme®
                Türkiye
              </li>
              <li>
                Güvende Olma, Bağlantı ve İnsan Deneyimi Konferansı – Dr.
                Porges, Dr. Carter ve Dr. Gomes
              </li>
              <li>
                Bilişsel Davranışçı Terapi Eğitimi – Prof. Dr. Mehmet Zihni
                Sungur Bilişsel Davranışçı Terapi Süpervizyonu – Prof. Dr.
                Mehmet Zihni Sungur
              </li>
            </ul>
          </section>

          <section aria-label="Kısa Süreli ve Çözüm Odaklı Yaklaşımlar">
            {/*<h3>Kısa Süreli ve Çözüm Odaklı Yaklaşımlar</h3>*/}
            <ul>
              <li>
                Psikodinamik Terapiler: Teori ve Uygulama Eğitimi ve Süpervizyon
                – Dr. Psk. Mia Medina
              </li>
              <li>
                Psikanalizle Tanışma Seminerleri – İstanbul Psikanaliz Derneği
                Bilişsel Davranışçı Terapi Eğitimi – Prof. Dr. Mehmet Zihni
                Sungur{" "}
              </li>
              <li>
                Çözüm Odaklı Kısa Süreli Terapi Eğitimi – Dr. Nevin Dölek{" "}
              </li>
              <li>Terapötik Kartları Eğitimi – Psk. Ceren Sezen</li>
              <li>Nöropsikolojik Test Eğitimi – Doc. Dr. Elvin Doğutepe</li>
              <li>MOXO Dikkat Testi Eğitimi – Dr. Ferda Korkmaz Özkanoğlu</li>
            </ul>
          </section>

          <section aria-label="Gülfem Dikici Çelikay Yayınları">
            <h3 className="m-4">YAYINLAR</h3>
            <ul>
              <li>
                Dikici, G. R. (2023). The impact of hunger on emotions: The
                mediating role of interoception and satiety responsiveness
                (Master’s thesis, University of Groningen). University of
                Groningen Student Theses Repository.
                https://gmwpublic.studenttheses.ub.rug.nl/id/eprint/2361
              </li>
              <li>
                Dikici, G. R. (2020). Etiology of addiction and dopamine.
                Journal of Experimental and Basic Medical Sciences, 1(1), 28–31.
                https://doi.org/10.5606/jebms.2020.75607
              </li>
            </ul>
          </section>
        </div>
      </div>
    </>
  );
}

export default About;
